import * as tslib_1 from "tslib";
import { Status } from '@sentry/types';
/** Noop transport */

var NoopTransport =
/** @class */
function () {
  function NoopTransport() {}
  /**
   * @inheritDoc
   */


  NoopTransport.prototype.sendEvent = function (_) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        return [2
        /*return*/
        , Promise.resolve({
          reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
          status: Status.Skipped
        })];
      });
    });
  };
  /**
   * @inheritDoc
   */


  NoopTransport.prototype.close = function (_) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        return [2
        /*return*/
        , Promise.resolve(true)];
      });
    });
  };

  return NoopTransport;
}();

export { NoopTransport };